export default {
  fillBilling({ commit }, billing) {
    commit("Order/Contract/updateShipping", billing.shipping, { root: true })
    commit("Order/Contract/updateDueDate", billing.dueDate, { root: true })
    commit("Order/Contract/updatePayment", billing.payment, { root: true })
    commit("setBank", billing.bank)
    commit("setAgency", billing.agency)
    commit("setAccount", billing.account)
    commit("setWhatsapp", billing.whatsapp || "")
    commit("setClientType", billing.clientType || "")
    commit("setContractType", billing.contractType || "")
    commit("setContractModel", billing.contractModel|| "")
    commit("setBillingAddress", billing.billingAddress || [])
    commit("setComplements", billing.complements || [])
  },
  createComplement({ commit, getters }, newComplement) {
    const newComplements = getters.getComplements
    newComplements.push(newComplement)

    commit("setComplements", newComplements)
  },
  deleteComplement({ commit, getters }, indexComplement) {
    const newComplements = getters.getComplements.filter(
      (complement, index) => index !== indexComplement
    )
    commit("setComplements", newComplements)
  },
  resetBilling({ commit }) {
    commit("resetBilling")
    commit("Order/Contract/resetContract", null, { root: true })
  }
}
